module.exports = "query GetDetailedCountries {\n  detailedCountries {\n    ...DetailedCountryFragment\n  }\n}\n"